import Utility from "../../../shared/utility.js";
import EncryptUtility from "../../utility/js/encrypt-utility.js";
import AddFavourite from "../../utility/js/addFav.js";
import breadcrumbComp from "../../common/breadcrumb-comp";
import materialMovementService from "./material-movement-service.js";
export default {
  data() {
    return {
      refresh: true,
      backSlash: true,
      actionList: [],
      mainPage: "",
      subPage: "",
      pageUrl: "",
      favouriteList: [],
      showAdd: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      lpnValid: false,
      userList: [],
      selectedUser: "",
      lpnNum: "",
      runUser: false, // true when user is selected from dropdown; disables LPN field
      runLPN: false,  // true when LPN is entered manually; disables Users dropdown
      lpnRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) => /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) || "Enter a correct format: 000-000-000-000",
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    this.getUsers();
  },
  methods: {
    //Resets the form and re-fetches the users list
    resetFunction() {
      this.selectedUser = "";
      this.userList = [];
      this.lpnNum = "";
      this.runUser = false;
      this.runLPN = false;
      this.lpnValid = false;
      this.$refs.resetLpnForm.resetValidation();
      this.getUsers();
    },
    //Loads the users dropdown on page load
    async getUsers() {
      let payload = { user_id: parseInt(this.userId) };
      let data = await materialMovementService.getResetLPNUsers("post", payload, false);
      if (data !== undefined && data.message !== "NA") {
        this.userList = data.UsersInfo;
      }
    },
    //When a user is selected: populates LPN from that user's data and disables LPN field
    //When selection is cleared: clears LPN and re-enables both fields
    onUserChange() {
      if (!this.selectedUser) {
        this.lpnNum = "";
        this.runUser = false;
        return;
      }
      const user = this.userList.find((u) => u.user_key === this.selectedUser);
      if (user) {
        this.lpnNum = user.lpn;
        this.runUser = true;
      }
    },
    //When LPN is typed manually: disables Users dropdown; clears it when LPN is empty
    onLPNChange() {
      if (this.lpnNum && this.lpnNum.trim().length > 0) {
        this.runLPN = true;
        this.selectedUser = "";
      } else {
        this.runLPN = false;
      }
    },
    //Calls the reset LPN API; shows success/error alert and keeps user on the page
    async resetLPN() {
      if (this.$refs.resetLpnForm.validate()) {
        let payload = {
          user_id: parseInt(this.userId),
          lpn: this.lpnNum.trim(),
        };
        let data = await materialMovementService.resetLPN("post", payload, false);
        if (data !== undefined) {
          let Alert = {
            type: "success",
            isShow: true,
            message: data,
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.resetFunction();
        }
      }
    },
    //Formats LPN input to 000-000-000 pattern
    lpnNumFormat(event, num) {
      this.lpnNum = Utility.formatLPNNumber(event, num);
    },
    //Adds or removes page from favourites
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
